import MultiRangeSlider from "../double range slider/MultiRangeSlider";
import Item from "./Sidebar-section-item";

const Section = ({ sectionData }) => {
  return (
    <div className=" mb-3">
      <h3 className="text-[20px] text-txtColor font-semibold my-2 font-sans ml-8">
        {sectionData[0]}
      </h3>
      <ul className="">
        {sectionData[1].length > 0 &&
          sectionData[1].map((itemValue, i) => {
            return (
              <li key={i}>
                <Item itemValue={itemValue} />
              </li>
            );
          })}
        {sectionData[1].length == 0 && (
          <MultiRangeSlider
            min={0}
            max={100}
            onChange={({ min, max }) =>
              console.log(`min = ${min}, max = ${max}`)
            }
          />
        )}
      </ul>
    </div>
  );
};

export default Section;
